export default __webpack_public_path__ + "static/media/1_en.1f4cbe15.png";